module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Da-Eb.cebb518a.png";